var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgPattern(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1800,
    height: 1140,
    viewBox: "0 0 1800 1140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_507_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 1801,
    height: 1140
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.146484,
    width: 1800,
    height: 1140,
    fill: "#F8FBFF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_507_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.854 -52V1195",
    stroke: "#1E78FF",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.854 -52V1195",
    stroke: "#1E78FF",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.854 -52V1195",
    stroke: "#1E78FF",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.854 -52V1195",
    stroke: "#1E78FF",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.854 -52V1195",
    stroke: "#1E78FF",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.854 -52V1195",
    stroke: "#1E78FF",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.854 -52V1195",
    stroke: "#1E78FF",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.85 -52V1195",
    stroke: "#1E78FF",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.85 -52V1195",
    stroke: "#1E78FF",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.85 -52V1195",
    stroke: "#1E78FF",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1534.85 -52V1195",
    stroke: "#1E78FF",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1674.85 -52V1195",
    stroke: "#1E78FF",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1798.85 85H0.853516",
    stroke: "#1E78FF",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1798.85 225H0.853516",
    stroke: "#1E78FF",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1798.85 365H0.853516",
    stroke: "#1E78FF",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1798.85 505H0.853516",
    stroke: "#1E78FF",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1798.85 645H0.853516",
    stroke: "#1E78FF",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1798.85 785H0.853516",
    stroke: "#1E78FF",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1798.85 925H0.853516",
    stroke: "#1E78FF",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1798.85 1065H0.853516",
    stroke: "#1E78FF",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.854,
    cy: 85,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.854,
    cy: 225,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.854,
    cy: 365,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.854,
    cy: 505,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.854,
    cy: 645,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 838.854,
    cy: 645,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 838.854,
    cy: 505,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 838.854,
    cy: 365,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 838.854,
    cy: 225,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 838.854,
    cy: 85,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 975.854,
    cy: 85,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 974.854,
    cy: 225,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 975.854,
    cy: 365,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 972.854,
    cy: 505,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976.854,
    cy: 645,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1115.85,
    cy: 645,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1113.85,
    cy: 505,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1114.85,
    cy: 365,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1115.85,
    cy: 225,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1113.85,
    cy: 85,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 416.854,
    cy: 85,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 416.854,
    cy: 225,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 416.854,
    cy: 365,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 416.854,
    cy: 505,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 416.854,
    cy: 645,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 557.854,
    cy: 645,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 557.854,
    cy: 505,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 557.854,
    cy: 365,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 557.854,
    cy: 225,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 557.854,
    cy: 85,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.854,
    cy: 85,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.854,
    cy: 225,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.854,
    cy: 365,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.854,
    cy: 505,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.854,
    cy: 645,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.854,
    cy: 645,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.854,
    cy: 505,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.854,
    cy: 365,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.854,
    cy: 225,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.854,
    cy: 85,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1254.85,
    cy: 85,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1255.85,
    cy: 225,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1256.85,
    cy: 365,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1254.85,
    cy: 505,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1256.85,
    cy: 645,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1397.85,
    cy: 645,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1395.85,
    cy: 505,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1396.85,
    cy: 365,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1395.85,
    cy: 225,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1395.85,
    cy: 85,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1533.85,
    cy: 85,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1533.85,
    cy: 225,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1534.85,
    cy: 365,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1533.85,
    cy: 505,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1534.85,
    cy: 645,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 699.854,
    cy: 785,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.854,
    cy: 785,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976.854,
    cy: 785,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1116.85,
    cy: 785,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 416.854,
    cy: 785,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 557.854,
    cy: 785,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139.854,
    cy: 785,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.854,
    cy: 785,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1256.85,
    cy: 786,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1396.85,
    cy: 785,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1533.85,
    cy: 785,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1674.85,
    cy: 785,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 699.854,
    cy: 925,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.854,
    cy: 925,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976.854,
    cy: 925,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1116.85,
    cy: 925,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 416.854,
    cy: 925,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 557.854,
    cy: 925,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139.854,
    cy: 925,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.854,
    cy: 925,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1256.85,
    cy: 926,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1396.85,
    cy: 925,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1533.85,
    cy: 925,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1674.85,
    cy: 925,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 699.854,
    cy: 1065,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.854,
    cy: 1065,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976.854,
    cy: 1065,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1116.85,
    cy: 1065,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 416.854,
    cy: 1065,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 557.854,
    cy: 1065,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139.854,
    cy: 1065,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.854,
    cy: 1065,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1256.85,
    cy: 1066,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1396.85,
    cy: 1065,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1533.85,
    cy: 1065,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1674.85,
    cy: 1065,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1674.85,
    cy: 645,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1674.85,
    cy: 505,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1674.85,
    cy: 365,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1674.85,
    cy: 225,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1674.85,
    cy: 85,
    r: 3,
    fill: "#D1DFF4",
    fillOpacity: 0.39
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPattern);
export default __webpack_public_path__ + "static/media/bg_pattern.d85534148cd450fdab916da713e719be.svg";
export { ForwardRef as ReactComponent };